import { Flex } from "@aircall/tractor";
import { PercentBadge } from "@/components/PercentBadge/PercentBadge";
import { PlaygroundSectionLayout } from "../PlaygroundSectionLayout/PlaygroundSectionLayout";
import { PlaygroundSubSectionLayout } from "../PlaygroundSubSectionLayout/PlaygroundSubSectionLayout";
import { PlaygroundSubSectionTitle } from "../PlaygroundSubSectionTitle/PlaygroundSubSectionTitle";

function BasicCase() {
  return (
    <Flex gap="s" flexWrap="wrap">
      <PercentBadge value={95} />
      <PercentBadge value={75} />
      <PercentBadge value={60} />
      <PercentBadge value={35} />
      <PercentBadge value={15} />
    </Flex>
  );
}

function EdgeCases() {
  return (
    <Flex gap="s" flexWrap="wrap">
      <PercentBadge value={null} />
      <PercentBadge value={-10} />
      <PercentBadge value={120} />
      <PercentBadge value={0} />
      <PercentBadge value={100} />
    </Flex>
  );
}

function BorderlessCase() {
  return (
    <Flex gap="s" flexWrap="wrap">
      <PercentBadge value={95} borderless />
      <PercentBadge value={75} borderless />
      <PercentBadge value={60} borderless />
      <PercentBadge value={35} borderless />
      <PercentBadge value={15} borderless />
      <PercentBadge value={null} borderless />
    </Flex>
  );
}

function RatingScaleExamples() {
  return (
    <Flex gap="m" flexDirection="column">
      <Flex gap="s" alignItems="center" flexWrap="wrap">
        <PercentBadge value={100} />
        <span>Excellent (85-100%)</span>
      </Flex>
      <Flex gap="s" alignItems="center" flexWrap="wrap">
        <PercentBadge value={77} />
        <span>Good (70-85%)</span>
      </Flex>
      <Flex gap="s" alignItems="center" flexWrap="wrap">
        <PercentBadge value={60} />
        <span>Fair (50-70%)</span>
      </Flex>
      <Flex gap="s" alignItems="center" flexWrap="wrap">
        <PercentBadge value={35} />
        <span>Poor (20-50%)</span>
      </Flex>
      <Flex gap="s" alignItems="center" flexWrap="wrap">
        <PercentBadge value={10} />
        <span>Very Poor (0-20%)</span>
      </Flex>
      <Flex gap="s" alignItems="center" flexWrap="wrap">
        <PercentBadge value={null} />
        <span>Not Applicable (null)</span>
      </Flex>
    </Flex>
  );
}

export function PlaygroundPercentBadge() {
  return (
    <PlaygroundSectionLayout>
      <PlaygroundSubSectionLayout>
        <PlaygroundSubSectionTitle>Basic Usage</PlaygroundSubSectionTitle>
        <BasicCase />
      </PlaygroundSubSectionLayout>

      <PlaygroundSubSectionLayout>
        <PlaygroundSubSectionTitle>
          Rating Scale Examples
        </PlaygroundSubSectionTitle>
        <RatingScaleExamples />
      </PlaygroundSubSectionLayout>

      <PlaygroundSubSectionLayout>
        <PlaygroundSubSectionTitle>Borderless</PlaygroundSubSectionTitle>
        <BorderlessCase />
      </PlaygroundSubSectionLayout>

      <PlaygroundSubSectionLayout>
        <PlaygroundSubSectionTitle>Edge Cases</PlaygroundSubSectionTitle>
        <EdgeCases />
      </PlaygroundSubSectionLayout>
    </PlaygroundSectionLayout>
  );
}
